import { PlaceholdersId, TFComponent } from '@types';
import { MembershipCompletionEnterpriseSolutionPlaceholder } from './membershipCompletionEnterpriseSolution';

export const membershipCompletionEnterpriseSolution: TFComponent = {
	component: MembershipCompletionEnterpriseSolutionPlaceholder,
	id: PlaceholdersId.membershipCompletionEnterpriseSolution,
	name: 'membershipCompletionEnterpriseSolution',
};
